export default [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/auth/Login.vue'),
    meta: {
      title: 'Login',
      guestOnly: true
    },
  },
  {
    path: '/logout',
    name: 'Logout',
    beforeEnter: (to, from, next) => {
      const store = require('@/store').default
      store.dispatch('auth/logout')
      next('/login')
    },
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('@/views/auth/ForgotPassword.vue'),
    meta: { 
      title: 'Forgot Password',
      guestOnly: true
    },
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('@/views/auth/ResetPassword.vue'),
    meta: { 
      title: 'Reset Password',
      guestOnly: true
    },
  },
  {
    path: '/accept-invite',
    name: 'AcceptInvite',
    component: () => import('@/views/users/AcceptInvite.vue'),
    meta: { 
      title: 'User Details', 
      requiresAuth: true,
      requiresAmazon: true,
    },
  }
]